import { TeamDetailed } from 'core/models/Tournament'
import TournamentChatTeam from '../TournamentChatTeam'

export default function TournamentChatTeamDetails({
  teamsDetailed,
  teamIdToClass,
  isGroupChat = false ,
}: {
  teamsDetailed: TeamDetailed[]
  teamIdToClass: Record<string, string>
  isGroupChat?: boolean
}) {
  return (
    <div className='tournamnet-teams-wrapper'>
      {teamsDetailed?.map((team: any, index: number) => {
        return <TournamentChatTeam key={index} team={team} teamIdToClass={teamIdToClass} isGroupChat={isGroupChat}/>
      })}
    </div>
  )
}
